export enum EDeliveryMethod {
    COURIER = 'courier',
    PICKUP_POINT = 'pickup-point',
}
